<template>
    <div :class="`${bootstrapClass[lowerCaseTenantDomainTheme]} ${bootstrapClass[lowerCaseTenantDomainTheme]}-${boxColor}`">
        <slot></slot>
    </div>
</template>

<script>
import Tag from '../../../../Utility/Tag.vue';
import {tenantDomainTheme} from "../../../../../mixins/tenantDomainTheme";

export default {
    name: 'ThemedBootstrapCard',

    components: {
        Tag,
    },

    mixins: [
        tenantDomainTheme,
    ],

    props: {
        boxColor: {
            default: 'default',
            required: false,
            type: String,
        },
        headerTag: {
            default: 'div',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            bootstrapClass: {
                artificialreason: 'panel',
                assan: 'card',
                eventrac: 'box',
            },
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCard.vue